let documentHandler;
export default {
  bind(el, binding) {
    documentHandler = e => {
      const dom = el || this.el
      if (dom && dom.contains(e.target)) {
        return false;
      }

      if (binding && binding.expression) {
        binding.value(e);
        return true;
      }

      if (this.vm && this.expression) {
        const fnExp = this.vm[this.expression]
        if (fnExp) {
          fnExp()
        } else {
          this.vm.$eval(this.expression)
        }
        return true
      }
      return false
    };
    document.addEventListener('click', documentHandler);
  },
  update() {},
  unbind() {
    document.removeEventListener('click', documentHandler);
  },
};
